import React from "react";
import { motion } from "framer-motion";
import SitePicture from "../SitePicture";

const HomePageBanner = () => {
  return (
    <section className="bg-white py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto grid md:grid-cols-2 rounded-3xl overflow-hidden shadow-2xl bg-brand-navy"
      >
        {/* Image */}
        <div className="relative h-64 md:h-auto overflow-hidden group">
          <SitePicture
            name="home/value-banner"
            sizes="(min-width: 768px) 640px, 100vw"
            alt="Civil construction site at dusk"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-transparent to-brand-navy/70" />
        </div>

        {/* Text */}
        <div className="p-8 sm:p-10 lg:p-14 text-center md:text-left flex flex-col justify-center">
          <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-brand-yellow">
            Corporate Brochure
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-white leading-tight">
            Adding Value at Every Stage
          </h2>
          <div className="mt-5 h-1 w-16 rounded-full bg-brand-yellow mx-auto md:mx-0" />
          <p className="mt-5 text-base text-blue-100 leading-relaxed">
            We enhance every phase of design, construction, and project
            management by embodying a culture of excellence. Download our
            Corporate Brochure to discover more about our commitment to quality
            and innovation in the civil construction sector.
          </p>
          <div className="mt-8">
            <a
              href={`${process.env.PUBLIC_URL}/RCB-Catalogue-2025.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-brand-yellow text-brand-navy font-bold py-3.5 px-8 rounded-full shadow-lg hover:bg-brand-gold hover:-translate-y-0.5 transition-all duration-300"
            >
              Download Our Brochure
              <span className="ml-1 font-semibold opacity-70">(PDF, 3.3 MB)</span>
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default HomePageBanner;
